/** The meetup page's motion. The meetup bar draws its own ticks (components/meetupBarNotes.js). */
import {EASING_CURVES} from '../../modules/motion/easing.js';

/** Milliseconds. */
const LANDING = Object.freeze({delay: 150, duration: 600});

/** Lands the place icon: a pin drops onto the map, a globe turns into place. */
function landPlaceIcon() {
    const icon = document.querySelector('.js-meetupPlaceIcon');
    if (!(icon instanceof SVGElement)) {
        return;
    }
    const keyframes = icon.dataset.iconName === 'globe' ? [{rotate: '-30deg'}, {rotate: '0deg'}] : [{translate: '0 -10px'}, {translate: '0 0'}];
    icon.animate(keyframes, {...LANDING, easing: EASING_CURVES.spring, fill: 'backwards'});
}

document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', landPlaceIcon) : landPlaceIcon();
